import React, {useState} from "react";

export function LoginPage({onAuthenticated}) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");
        try {
            const response = await fetch("/api/auth/login", {
                method: "POST",
                credentials: "include",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({username, password}),
            });
            const body = await response.json().catch(() => ({}));
            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    throw new Error("Invalid username or password.");
                }
                if (response.status === 502 || response.status === 503 || response.status === 504) {
                    throw new Error("The authentication service is temporarily unavailable. Please try again.");
                }
                throw new Error(body.error || "Unable to sign in. Please try again.");
            }
            setPassword("");
            await onAuthenticated();
        } catch (loginError) {
            setError(loginError?.message || "Unable to sign in. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="auth-shell">
            <section className="auth-card" aria-labelledby="login-title">
                <div className="eyebrow">Wisp Capital</div>
                <h1 id="login-title">Strategy Registry</h1>
                <p className="auth-lede">Sign in with your Wisp Capital account to view live strategy data.</p>
                <form className="auth-form" onSubmit={submit}>
                    {error && <div className="auth-error" role="alert">{error}</div>}
                    <label>
                        <span>Username</span>
                        <input
                            autoComplete="username"
                            autoFocus
                            disabled={loading}
                            onChange={(event) => setUsername(event.target.value)}
                            required
                            value={username}
                        />
                    </label>
                    <label>
                        <span>Password</span>
                        <input
                            autoComplete="current-password"
                            disabled={loading}
                            onChange={(event) => setPassword(event.target.value)}
                            required
                            type="password"
                            value={password}
                        />
                    </label>
                    <button className="button auth-submit" disabled={loading} type="submit">
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
                <p className="auth-footnote">Authentication is provided by the shared Wisp Capital account service.</p>
            </section>
        </main>
    );
}
